import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { MailOutline, Person, Phone } from "@mui/icons-material";
import { OrderInfoCard, type OrderInfoItem } from "./OrderInfoCard";

type ClientInfoCardProps = {
	order?: OrderDetailResponseDto;
};

export function ClientInfoCard({ order }: ClientInfoCardProps) {
	if (!order?.customer) return null;

	const { customer } = order;

	const items: OrderInfoItem[] = [
		{
			icon: <Phone fontSize="small" />,
			label: "Phone",
			value: customer.phone,
			show: !!customer.phone,
		},
		{
			icon: <MailOutline fontSize="small" />,
			label: "Email",
			value: customer.email,
			show: !!customer.email,
		},
	];

	return (
		<OrderInfoCard
			title="Client"
			titleIcon={<Person fontSize="small" />}
			mainValue={customer.name}
			items={items}
		/>
	);
}
